import { Button, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { useFlexibleStepper } from 'src/components/FlexibleStepper/useFlexibleStepper';
import CountriesPhoneInput from 'src/components/common/form/CountriesPhoneInput';
import { PhoneInputStepProps } from 'src/features/auth/presentation/components/SignUpStepper/SignUpStepper.types';
import useTrackAuthEvents from 'src/features/auth/presentation/hooks/useTrackAuthEvents';

export default function PhoneInputStep({
  onSubmit,
  disableNext,
  description,
  title,
  submitLabel,
  fieldKey = 'phone_number',
  readOnly,
}: PhoneInputStepProps) {
  const stepperContext = useFlexibleStepper();
  const { trackRegistrationFieldBlur } = useTrackAuthEvents();
  const { values, setFieldValue, handleBlur, touched, errors } =
    useFormikContext<{ [x: typeof fieldKey]: string }>();

  const hasErrors = Boolean(errors[fieldKey]);
  const isPhoneEmpty = !values[fieldKey];
  const disableSubmit = hasErrors || isPhoneEmpty || disableNext;

  return (
    <>
      <Typography
        variant="h5"
        textAlign="center"
        fontWeight="fontWeightMedium"
        gutterBottom
      >
        {title ?? 'Ingresa tu número de teléfono'}
      </Typography>
      {description && (
        <Typography
          textAlign="left"
          variant="body1"
          fontWeight="fontWeightRegular"
        >
          {description}
        </Typography>
      )}

      <CountriesPhoneInput
        id={fieldKey}
        name={fieldKey}
        onChange={(value: string) => {
          setFieldValue(fieldKey, value);
        }}
        required
        label="Teléfono"
        type="tel"
        placeholder="Teléfono"
        value={values[fieldKey]}
        onBlur={handleBlur}
        onInputTrack={trackRegistrationFieldBlur}
        error={
          touched[fieldKey] &&
          !!errors[fieldKey] &&
          values[fieldKey]?.length > 3
        }
        helperText={
          touched[fieldKey] && values[fieldKey]?.length > 3
            ? errors[fieldKey]
            : ''
        }
        InputProps={{ readOnly }}
      />

      <Button
        variant="contained"
        color="primary"
        size="large"
        disabled={disableSubmit}
        onClick={() => onSubmit(stepperContext)}
        sx={{ marginTop: 'auto' }}
      >
        {submitLabel ?? 'Continuar'}
      </Button>
    </>
  );
}
